import React from "react";
import { Box, Grid, Typography, Stack, Divider, IconButton } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";

const FOOTER_LINKS = {
  "Services": [
    { label: "Mobile Recharge", path: "/dashboard/bbps/mobileprepaid" },
    { label: "Electricity Bill", path: "/dashboard/bbps/Electricity" },
    { label: "DTH Recharge", path: "/dashboard/bbps/DTH" },
    { label: "FASTag", path: "/dashboard/bbps/Fastag" },
    { label: "Gift Cards", path: "/dashboard/giftcard" },
  ],
  "Company": [
    { label: "About Us", path: "/" },
    { label: "Help Center", path: "/helpcenterlayout" },
    { label: "Terms & Conditions", path: "/termsandconditions" },
    { label: "Privacy Policy", path: "/termsandconditions" },
    { label: "Grievance", path: "/dashboard/grievance" },
  ],
  "Account": [
    { label: "Sign In", path: "/login" },
    { label: "Register", path: "/registration" },
    { label: "Profile Settings", path: "/profile-settings" },
    { label: "Transaction History", path: "/profile-settings/transactionhistory" },
  ],
};

export default function Footer() {
  const navigate = useNavigate();

  return (
    <Box sx={{ bgcolor: "#020617", color: "white" }}>
      <Box sx={{ px: { xs: 3, md: 8, lg: 12 }, pt: { xs: 8, md: 10 }, pb: 6 }}>
        <Grid container spacing={{ xs: 4, md: 6 }}>
          {/* Brand column */}
          <Grid item xs={12} md={4}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 3 }}>
              <Box sx={{ width: 40, height: 40, borderRadius: "11px", background: "linear-gradient(135deg, #16a34a, #22c55e)", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 4px 14px rgba(22,163,74,0.4)" }}>
                <Box component="img" src="/Assets/ta_walletlogo.png" sx={{ height: 24, filter: "brightness(0) invert(1)" }} onError={(e)=>{e.target.style.display="none";}} />
              </Box>
              <Box>
                <Typography sx={{ fontWeight: 800, fontSize: 18, color: "white", lineHeight: 1 }}>TA Wallet</Typography>
                <Typography sx={{ fontSize: 10, color: "#4ade80", fontWeight: 600 }}>ONE APP</Typography>
              </Box>
            </Box>

            <Typography sx={{ fontSize: 14, color: "#94a3b8", lineHeight: 1.8, mb: 3, maxWidth: 300 }}>
              India's trusted digital wallet for secure, instant, and transparent payments. RBI registered and BBPS certified.
            </Typography>

            {/* Contact */}
            <Stack spacing={1.5} mb={4}>
              {[
                { icon: "📍", text: "1st Floor, Satyam Arcade, BTM 2nd Stage, Bengaluru - 560076" },
                { icon: "📞", text: "+91-9390358339" },
                { icon: "✉️", text: "support@taipl.in" },
              ].map((c, i) => (
                <Box key={i} sx={{ display: "flex", gap: 1.5, alignItems: "flex-start" }}>
                  <Box sx={{ fontSize: 14, mt: 0.2, flexShrink: 0 }}>{c.icon}</Box>
                  <Typography sx={{ fontSize: 13, color: "#64748b", lineHeight: 1.6 }}>{c.text}</Typography>
                </Box>
              ))}
            </Stack>

            {/* App download */}
            <Stack direction="row" spacing={1.5}>
              <Box component="img" src="/Assets/Googleplay.png" sx={{ height: 38, cursor: "pointer", borderRadius: "8px", opacity: 0.85, "&:hover": { opacity: 1 } }}
                onClick={() => window.open("https://play.google.com/store/apps/details?id=com.ta.wallet.tawallet", "_blank")}
                onError={(e) => { e.target.style.display = "none"; }}
              />
              <Box component="img" src="/Assets/Playstore.png" sx={{ height: 38, cursor: "pointer", borderRadius: "8px", opacity: 0.85, "&:hover": { opacity: 1 } }}
                onClick={() => window.open("https://apps.apple.com/in/app/ta-wallet/id1381087275", "_blank")}
                onError={(e) => { e.target.style.display = "none"; }}
              />
            </Stack>
          </Grid>

          {/* Link columns */}
          {Object.entries(FOOTER_LINKS).map(([section, links]) => (
            <Grid item xs={6} md={8/3} key={section}>
              <Typography sx={{ fontWeight: 700, fontSize: 13, color: "#e2e8f0", mb: 2.5, textTransform: "uppercase", letterSpacing: "1px" }}>
                {section}
              </Typography>
              <Stack spacing={1.5}>
                {links.map((link) => (
                  <Typography key={link.label}
                    component={Link} to={link.path}
                    sx={{ fontSize: 14, color: "#64748b", textDecoration: "none", display: "block", transition: "color 0.15s", "&:hover": { color: "#4ade80" } }}>
                    {link.label}
                  </Typography>
                ))}
              </Stack>
            </Grid>
          ))}
        </Grid>

        <Divider sx={{ borderColor: "#1e293b", my: 6 }} />

        {/* Bottom bar */}
        <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, justifyContent: "space-between", alignItems: "center", gap: 2 }}>
          <Typography sx={{ fontSize: 13, color: "#475569" }}>
            © 2024 Transaction Analysts India Pvt. Ltd. All rights reserved.
          </Typography>
          <Box sx={{ display: "flex", gap: 3, alignItems: "center" }}>
            {["/Assets/iso_img_1.jpg", "/Assets/Pci_img.png", "/Assets/iso_img_2.png"].map((src, i) => (
              <Box key={i} component="img" src={src} sx={{ height: 28, opacity: 0.4, filter: "brightness(2)", "&:hover": { opacity: 0.8 } }} onError={(e) => { e.target.style.display = "none"; }} />
            ))}
            <Typography sx={{ fontSize: 12, color: "#334155" }}>RBI Compliant · BBPS · ISO 27001</Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
